import { defineComponent, onMounted, ref } from "vue";
import gsap from "gsap/all";
export default defineComponent({
  props: {
    href: { type: String, required: true },
    label: { type: String, required: true },
    target: { type: String, required: false },
    color: { type: String, default: "black" },
    fontweight: { type: String, default: "bold" },
    elementType: { type: String, default: "a" },
    noHover: { type: Boolean, default: false },
    icon: { type: String, default: "" },
  },
  setup(props) {
    const button = ref<HTMLElement | null>(null);
    const hoverTween = ref(gsap.timeline());
    const hoverOffTween = ref(gsap.timeline());

    onMounted(() => {
      const background = button.value!.querySelector(".button__background");
      const label = button.value!.querySelector(".button__label");

      gsap.set(background, {
        transformOrigin: "center bottom",
        yPercent: 100,
      });

      hoverTween.value = gsap
        .timeline({ overwrite: true })
        .fromTo(background, { yPercent: 100 }, { yPercent: 0 })
        .pause();

      // hoverTween.value = gsap
      //   .timeline({ overwrite: true })
      //   .to(background, {
      //     yPercent: 0,
      //     duration: 0.4,
      //     ease: "power4.out",
      //   })

      //   .to(label, { yPercent: -100 }, 0)
      //   .pause();

      hoverOffTween.value = gsap
        .timeline({
          overwrite: true,
          onComplete: () => {
            gsap.set(background, {
              yPercent: 100,
            });
          },
        })
        .to(background, {
          yPercent: -100,
          duration: 0.4,
          ease: "power4.inOut",
        })

        // .to(label, { color: "#ffce32" }, 0)
        .pause();
    });

    const hover = (): void => {
      if (props.noHover) return;

      hoverOffTween.value.pause();
      hoverTween.value.play(0);
    };

    const hoverOff = (): void => {
      if (props.noHover) return;

      hoverTween.value.pause();
      hoverOffTween.value.play(0);
    };

    return { button, hover, hoverOff };
  },
});
